import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { isManager } from '@plone/volto/helpers/User/User';
export const LocationBlockSlot = (props, ...rest) => {
  const user = useSelector((state) => state.users.user);
  return isManager(user) ? (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <UniversalLink className="ui button" item={props.content.parent}>
        <FormattedMessage id="Go to location" defaultMessage="Go to location" />
      </UniversalLink>
    </div>
  ) : (
    <></>
  );
};
